import Moment from 'moment-timezone'

export type VendorPricingAgreement = {
  id: string
  scope: VendorPricingAgreementScope
  serviceTypes: VendorPricingAgreementServiceType[]
  vendorId: string | null
  hqId: number | null
  tiers: VendorPricingAgreementTier[]
  active: boolean
  lastUpdatedBy?: string
  createdAt?: Moment.Moment
  updatedAt?: Moment.Moment
}

export type VendorPricingAgreementScope =
  | 'universal'
  | 'market'
  | 'vendor_market'
export const VendorPricingAgreementScopes: Record<
  string,
  VendorPricingAgreementScope
> = {
  UNIVERSAL: 'universal',
  MARKET: 'market',
  VENDOR_MARKET: 'vendor_market',
}

export type VendorPricingAgreementServiceType = 'catering' | 'group_order'
export const VendorPricingAgreementServiceTypes: Record<
  string,
  VendorPricingAgreementServiceType
> = {
  CATERING: 'catering',
  GROUP_ORDER: 'group_order',
}
export const ServiceTypeToString = (
  serviceType: VendorPricingAgreementServiceType,
) => {
  switch (serviceType) {
    case VendorPricingAgreementServiceTypes.CATERING:
      return 'Catering'
    case VendorPricingAgreementServiceTypes.GROUP_ORDER:
      return 'Group Order'
    default:
      return 'Unknown'
  }
}

export type VendorPricingAgreementTier = {
  lowerLimit: number
  upperLimit: number | null
  discountPercentage: number
  position: number
}

export type ApiVendorPricingAgreement = {
  id: string
  scope: VendorPricingAgreementScope
  serviceTypes: VendorPricingAgreementServiceType[]
  vendorId: string | null
  hqId: number | null
  tiers: ApiVendorPricingAgreementTier[]
  active: boolean
  lastUpdatedBy?: string
  createdAt: string
  updatedAt: string
}

export type ApiVendorPricingAgreementTier = {
  lowerLimit: string
  upperLimit: string | null
  discountPercentage: string
  position: number
}

export const apiVendorPricingAgreementToVendorPricingAgreement = (
  apiVendorPricingAgreement: ApiVendorPricingAgreement,
): VendorPricingAgreement => {
  const { tiers, createdAt, updatedAt, ...rest } = apiVendorPricingAgreement

  const out = {
    ...rest,
    createdAt: Moment(createdAt),
    updatedAt: Moment(updatedAt),
    tiers: tiers.map(apiVendorPricingAgreementTierToVendorPricingAgreementTier),
  }

  return out
}

export const apiVendorPricingAgreementTierToVendorPricingAgreementTier = (
  apiVendorPricingAgreementTier: ApiVendorPricingAgreementTier,
): VendorPricingAgreementTier => {
  const { lowerLimit, upperLimit, discountPercentage, position } =
    apiVendorPricingAgreementTier

  const out = {
    lowerLimit: Number(lowerLimit),
    upperLimit: upperLimit ? Number(upperLimit) : null,
    discountPercentage: Number(discountPercentage),
    position,
  }

  return out
}

export type SearchVendorPricingAgreementsParams = {
  ids?: string[]
  scope?: VendorPricingAgreementScope
  scopes?: VendorPricingAgreementScope[]
  vendorId?: string
  vendorIds?: string[]
  hqId?: number
  hqIds?: number[]
  active?: boolean
  offset: number
  limit: number
}
